import { render, staticRenderFns } from "./PostAside.vue?vue&type=template&id=35d53662&"
import script from "./PostAside.vue?vue&type=script&lang=js&"
export * from "./PostAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports